module.exports = __webpack_public_path__ + "static/media/instagram.eee3b731.svg";